import { render, staticRenderFns } from "./IntentBulkCreatePage.vue?vue&type=template&id=d0a0b718"
import script from "./IntentBulkCreatePage.vue?vue&type=script&lang=js"
export * from "./IntentBulkCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports